
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 7c0-.977-.601-1.823-1.496-2.281.315-.95.137-1.98-.553-2.67-.69-.69-1.72-.868-2.67-.553C8.831.6 7.977 0 7 0c-.977 0-1.823.601-2.274 1.496-.956-.315-1.987-.137-2.677.553-.69.69-.86 1.72-.547 2.67C.608 5.177 0 6.023 0 7c0 .977.608 1.823 1.502 2.281-.314.95-.143 1.98.547 2.67.69.69 1.72.86 2.67.553C5.177 13.4 6.023 14 7 14c.977 0 1.83-.601 2.281-1.496.95.308 1.98.137 2.67-.553.69-.69.867-1.72.553-2.67C13.4 8.823 14 7.977 14 7zM5.47 9.336L3.933 7.797a.686.686 0 01-.002-.968.68.68 0 01.963-.003l.002.002.839.838a.3.3 0 00.433-.009L8.77 4.82a.681.681 0 01.962-.041l.002.001c.278.257.296.69.04.97L6.511 9.312a.72.72 0 01-1.04.023z","fill":"currentColor"}})])
          )
        }
      }
    